import React from 'react';

import type { FrapiTeaserItemSized } from '../../../types/frapi-types.js';

import Price from '../articles/articleComponents/Price.js';
import TeaserWrapper from './TeaserWrapper.js';
import {
  filterTagsOnType,
  isMovieReview,
  isRestaurantReview,
  isReview,
  makeTagTitle,
} from '../articles/helpers.js';
import { orderTeaserTags } from '../search/helpers.js';
import { hasPrice } from '../commonComponents/imageUtils.js';

const TeaserSearch: React.FC<FrapiTeaserItemSized> = (teaser) => {
  const { grade, className } = teaser;

  const Grade = (
    <div className="teaser-grade">
      {grade}
      <span>/6</span>
    </div>
  );

  const filteredTags = filterTagsOnType(teaser.tags, [
    'område',
    'type',
    'mattype',
    'strømmetjeneste',
  ]);

  const TagCollection = () => (
    <div className="tag-wrapper">
      {orderTeaserTags(filteredTags).map((t) => (
        <div className="regular-tag" key={t.id}>
          {makeTagTitle(t.title)}
        </div>
      ))}
    </div>
  );

  const reviewTitle = teaser.kicker || teaser.title;
  const isGuide = !isReview(teaser);

  const classNames = [
    'teaser-search',
    className,
    isRestaurantReview(teaser) ? 'restaurant' : '',
    isMovieReview(teaser) ? 'movie' : '',
    isGuide ? 'guide' : '',
  ].join(' ');

  return (
    <TeaserWrapper
      classNames={classNames}
      teaser={teaser}
      pageType="search:teaser-preview"
    >
      <div className="text" role="presentation">
        <div className="teaser-title">
          {!isGuide ? reviewTitle : teaser.title}
        </div>

        <div className="teaser-extra-info">
          {!isGuide && grade && Grade}
          {isGuide && <div className="guide-tag">Guide</div>}
          {teaser.tags.length > 0 && <TagCollection />}
          {!isGuide && hasPrice(teaser) && isRestaurantReview(teaser) && (
            <Price price={teaser.priceLevel} />
          )}
        </div>
      </div>
    </TeaserWrapper>
  );
};
export default TeaserSearch;
